<template>
  <div class="pro-page auto">
    <div class="imgbox auto"><img src="../../assets/activity/ncity/banner1.png?v=4" alt=""></div>
    <!-- <div class="imgbox auto"><img v-lazy="url + '/activity/nlounge/new/2.jpg?v=2'" alt=""></div> -->

    <div class="fixed-header auto" v-if="showHeader">
      <img src="../../assets/activity/ncity/open-title-1.png" v-if="showHeaderNum === 1" @click="clickTab(1)" alt="">
      <img src="../../assets/activity/ncity/open-title-2.png?v=1" v-if="showHeaderNum === 2" @click="clickTab(2)" alt="">
      <img src="../../assets/activity/ncity/open-title-3.png" v-if="showHeaderNum === 3" @click="clickTab(3)" alt="">
      <img src="../../assets/activity/ncity/open-title-4.png" v-if="showHeaderNum === 4" @click="clickTab(4)" alt="">
      <img src="../../assets/activity/ncity/open-title-5.png?v=1" v-if="showHeaderNum === 5" @click="clickTab(5)" alt="">
    </div>

    <div class="openbox auto" @click="clickTab(1)" id="openbox1">
      <div class="openbox-con auto" :style="{
        height: openList.indexOf(1) > -1 ? listHeight[0] : '21.86vw'
      }">
        <img src="../../assets/activity/ncity/1.png" class="titleimg" id="title1" v-show="openList.indexOf(1) < 0" alt="">
        <div class="openbox-full auto" id="openboxFull1">
          <img src="../../assets/activity/ncity/1-open.png?v=1" alt="">
        </div>
      </div>
      <!-- <div class="icon auto">
        <img src="../../assets/activity/ncity/icon-close.png" v-if="openList.indexOf(1) > -1" alt="">
        <img src="../../assets/activity/ncity/icon-open.png" v-else alt="">
      </div> -->
    </div>
    
    <div class="openbox auto" @click="clickTab(2)" id="openbox2">
      <div class="openbox-con auto" :style="{
        height: openList.indexOf(2) > -1 ? listHeight[1] : '21.86vw'
      }">
        <img src="../../assets/activity/ncity/2.png?v=1" class="titleimg" v-show="openList.indexOf(2) < 0" alt="">
        <div class="openbox-full auto" id="openboxFull2">
          <img src="../../assets/activity/ncity/2-open.png?v=1" alt="">
        </div>
      </div>
      <!-- <div class="icon auto">
        <img src="../../assets/activity/ncity/icon-close.png" v-if="openList.indexOf(2) > -1" alt="">
        <img src="../../assets/activity/ncity/icon-open.png" v-else alt="">
      </div> -->
    </div>
    
    <div class="openbox auto" @click="clickTab(3)" id="openbox3">
      <div class="openbox-con auto" :style="{
        height: openList.indexOf(3) > -1 ? listHeight[2] : '21.86vw'
      }">
        <img src="../../assets/activity/ncity/3.png?v=1" class="titleimg" v-show="openList.indexOf(3) < 0" alt="">
        <div class="openbox-full auto" id="openboxFull3">
          <img src="../../assets/activity/ncity/3-open.png?v=4" alt="">
        </div>
      </div>
      <!-- <div class="icon auto">
        <img src="../../assets/activity/ncity/icon-close.png" v-if="openList.indexOf(3) > -1" alt="">
        <img src="../../assets/activity/ncity/icon-open.png" v-else alt="">
      </div> -->
    </div>
    
    <div class="openbox auto" @click="clickTab(4)" id="openbox4">
      <div class="openbox-con auto" :style="{
        height: openList.indexOf(4) > -1 ? listHeight[3] : '21.86vw'
      }">
        <img src="../../assets/activity/ncity/4.png" class="titleimg" v-show="openList.indexOf(4) < 0" alt="">
        <div class="openbox-full auto" id="openboxFull4">
          <img src="../../assets/activity/ncity/4-open1.png?v=3" alt="">
          <img src="../../assets/activity/ncity/4-open2.png?v=3" alt="">
          <img src="../../assets/activity/ncity/4-open3.png?v=4" alt="">
          <img src="../../assets/activity/ncity/4-open4.png?v=3" alt="">
          <img src="../../assets/activity/ncity/4-open5.png?v=3" alt="">
        </div>
      </div>
      <!-- <div class="icon auto">
        <img src="../../assets/activity/ncity/icon-close.png" v-if="openList.indexOf(4) > -1" alt="">
        <img src="../../assets/activity/ncity/icon-open.png" v-else alt="">
      </div> -->
    </div>
    
    <div class="openbox auto" @click="clickTab(5)" id="openbox5">
      <div class="openbox-con auto" :style="{
        height: openList.indexOf(5) > -1 ? listHeight[4] : '21.86vw'
      }">
        <img src="../../assets/activity/ncity/5.png?v=1" class="titleimg" v-show="openList.indexOf(5) < 0" alt="">
        <div class="openbox-full auto" id="openboxFull5">
          <img src="../../assets/activity/ncity/5-open.png?v=3" alt="">
        </div>
      </div>
      <!-- <div class="icon auto">
        <img src="../../assets/activity/ncity/icon-close.png" v-if="openList.indexOf(5) > -1" alt="">
        <img src="../../assets/activity/ncity/icon-open.png" v-else alt="">
      </div> -->
    </div>

    <div class="imgbox auto" id="openbox6" style="margin-top: 7.5vw;"><img src="../../assets/activity/ncity/6.png?v=3" alt=""></div>
    <div class="imgbox auto"><img src="../../assets/activity/ncity/7.png?v=3" alt=""></div>

    <div class="auto" style="height: 20vw;"></div>

    <!-- <div class="footer auto">
      <div class="nlounge-btn atuo">
        <img src="../../assets/activity/ncity/btn.png?v=3" id="nlounge-btn" alt="">
      </div>
    </div> -->

    <div class="tips-alert" v-if="showUpdate">
      <div class="tips-alert-content auto">
        <div class="tips-title auto fontBold">提示</div>
        <div class="tips-content auto">
          当前版本过低，请更新版本再试！
          <!-- {{ NVersion }} -->
        </div>
        <div class="tips-btn-box auto">
          <div class="tips-btn cur auto fontBold" @click="goDownload">去升级</div>
          <!-- <div class="tips-btn auto fontBold" v-if="!hideCancel" @click.stop="cancelHandle">{{cancelText}}</div> -->
        </div>
        <!-- <div class="tips-btn-cancel auto">
          <div @click.stop="cancelHandle">忽略此版本</div>
        </div> -->
      </div>
    </div>

  </div>
</template>

<script>
import Config from '@/conf'
export default {
  data () {
    return {
      // url: 'https://elantran-cnd.vintro.cn/elantra_n_client_activity/images'
      url: Config.root + '/elantra_n_client_activity/images',
      showUpdate: false,
      NVersion: 0,
      openList: [],
      listHeight: [],
      showHeader: false,
      showHeaderNum: 0
    }
  },
  mounted(){
    var ua = navigator.userAgent.toLowerCase();
    if(ua.match(/MicroMessenger/i)=="micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        this.$wx.miniProgram.getEnv((res)=>{
            if (res.miniprogram) {
              // alert("在小程序里");
              document.querySelector('#nlounge-btn').addEventListener('click', () => {
                this.$wx.miniProgram.navigateTo({
                  // url: '/pages/activity/form/detail?id=cde647dedafa2254307bec079641e05a' // 正式
                  url: '/pages/activity/form/detail?id=46c3832a92c8fe47b9e55042ae76f324' // 测试
                })
              })
              document.querySelector('#nlounge-btn-my').addEventListener('click', () => {
                this.$wx.miniProgram.navigateTo({
                  url: '/pages/center/order'
                })
              })

              this.$wx.miniProgram.postMessage({
                data: {
                  title: '上海现代N城市体验中心盛大开业！'
                }
              })

            } else {
                console.log("不在小程序里");
            }
        })
    }else{
      // let search = this.$util.deserialize(window.location.search && window.location.search.slice(1))
      // this.NVersion = search['NVersion']
      // if (!search['NVersion'] || Number(search['NVersion']) < 136) {
      //   this.showUpdate = true
      // }
      // console.log(this.$route.query)
      // this.NVersion = this.$route.query['NVersion']
      // if (!this.$route.query['NVersion'] || Number(this.$route.query['NVersion']) < 136) {
      //   this.showUpdate = true
      // }
      // alert('不在微信里');
      document.addEventListener('UniAppJSBridgeReady', function() {
        document.querySelector('#nlounge-btn').addEventListener('click', function() {
          if (window.uni) {
            window.uni.navigateTo({
              // url: '/pages/activity/form/detail?id=cde647dedafa2254307bec079641e05a' // 正式
              url: '/pages/activity/form/detail?id=46c3832a92c8fe47b9e55042ae76f324' // 测试
            })
          }
        })
        document.querySelector('#nlounge-btn-my').addEventListener('click', function() {
          if (window.uni) {
            window.uni.navigateTo({
              url: '/pages/center/order'
            })
          }
        })
      })
    }

    document.addEventListener('scroll', () => {
      this.scrollFn()
    })
  },
  methods: {
    scrollFn () {
      var scrollY = window.scrollY
      
      var openbox1Top = document.querySelector('#openbox1').offsetTop
      var openbox2Top = document.querySelector('#openbox2').offsetTop
      var openbox3Top = document.querySelector('#openbox3').offsetTop
      var openbox4Top = document.querySelector('#openbox4').offsetTop
      var openbox5Top = document.querySelector('#openbox5').offsetTop
      var openbox6Top = document.querySelector('#openbox6').offsetTop

      var titleHeight = document.querySelector('#title1').clientHeight + 100

      if (scrollY > openbox1Top) {
        this.showHeader = true
      } else {
        this.showHeader = false
      }

      if (scrollY > openbox1Top && scrollY < (openbox2Top - titleHeight) && this.openList.indexOf(1) > -1) {
        this.showHeaderNum = 1
      } else if (scrollY > openbox2Top && scrollY < (openbox3Top - titleHeight) && this.openList.indexOf(2) > -1) {
        this.showHeaderNum = 2
      } else if (scrollY > openbox3Top && scrollY < (openbox4Top - titleHeight) && this.openList.indexOf(3) > -1) {
        this.showHeaderNum = 3
      } else if (scrollY > openbox4Top && scrollY < (openbox5Top - titleHeight) && this.openList.indexOf(4) > -1) {
        this.showHeaderNum = 4
      } else if (scrollY > openbox5Top && scrollY < (openbox6Top - titleHeight) && this.openList.indexOf(5) > -1) {
        this.showHeaderNum = 5
      } else {
        this.showHeaderNum = 0
      }

      // console.log('scrollY', scrollY)
      // console.log('openbox1Top', openbox1Top)
      // console.log('openbox2Top', openbox2Top)
      // console.log('openbox3Top', openbox3Top)
      // console.log('openbox4Top', openbox4Top)
      // console.log('openbox5Top', openbox5Top)
      // console.log('openbox6Top', openbox6Top)
      // console.log('titleHeight', titleHeight)
      // console.log('openList', this.openList)
      // console.log('showHeader', this.showHeader)
      // console.log('showHeaderNum', this.showHeaderNum)
      // console.log('-----------------------------------')

    },
    clickTab (num) {
      let height = document.querySelector('#openboxFull' + num).clientHeight
      console.log(height)
      this.listHeight[num - 1] = height + 'px'
      if (this.openList.indexOf(num) > -1) {
        this.openList.splice(this.openList.indexOf(num), 1)
      } else {
        this.openList.push(num)
      }
    },
    goDownload () {
      this.$router.push('/download')
    }
  }
}
</script>

<style lang="scss" scoped>
.pro-page {
  background: #000;
}
.nlounge-btn {
  img {
    width: 86vw;
    margin: 0 auto;
  }
}

.footer {
  padding: 5vw 0 5vw;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  background: #000;
  z-index: 99;
  .nlounge-btn-my {
    img {
      width: 17vw;
      margin: 3vw auto 0;
    }
  }
}


.tips-alert {
    position: fixed;
    display: flex;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, .76);
    z-index: 999;
    align-items: center;
    justify-content: center;
}
.tips-alert-content {
    width: 84%;
    .tips-title{
        height: 50px;
        background: #fff;
        text-align: center;
        line-height: 50px;
        font-size: 17px;
        color: #000;
    }
    .tips-content {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        color: #000;
        background: #fff;
        padding: 0 10%;
        height: 115px;
        // text-align: center;
    }
    .tips-btn-box {
        display: flex;
        background: #fff;
        padding-bottom: 16px;
        justify-content: center;
        gap: 13px;
        .tips-btn {
            width: 35%;
            text-align: center;
            background: #c2d6f0;
            height: 40px;
            color: #000;
            font-size: 15px;
            line-height: 40px;
        }
        .cur {
            background: #e33521;
            color: #fff;
        }
    }
  .tips-btn-boxbetween {
    // justify-content: space-between;
    .tips-btn {
      margin: 0 3vw;
    }
  }
}
.tips-btn-cancel {
    background: #fff;
    text-align: center;
    color: #666;
    font-size: 12px;
    padding-bottom: 20px;
    text-decoration: underline;
}

.fixed-header {
  width: 90%;
  position: fixed;
  left: 5%;
  top: -1px;
  z-index: 99;
  background: #272727;
}

.openbox {
  width: 90%;
  margin: 7.5vw auto 0;
  position: relative;
}
.openbox-con {
  height: 21.86vw;
  position: relative;
  transition: all .5s;
  .openbox-full {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.titleimg {
  position: relative;
  z-index: 9;
}
.icon {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 1vw;
  img {
    width: 5vw;
  }
}
</style>